import axios from 'axios'

const rentsUrl =
  'https://633c681b74afaef16408a698.mockapi.io/jamesAondowase/metrics'

export const getRents = async (id) => {
  id = id || ''
  try {
    return await axios.get(`${rentsUrl}/${id}`)
  } catch (error) {
    console.log('Error while calling getrents api ', error)
  }
}

export const addRent = async (rent) => {
  return await axios.post(`${rentsUrl}`, rent)
}

export const deleteRent = async (id) => {
  return await axios.delete(`${rentsUrl}/${id}`)
}

export const editRent = async (id, rent) => {
  return await axios.put(`${rentsUrl}/${id}`, rent)
}
